import * as React from 'react';

import { ChatPlugin } from '@common/react/components/Chat/Chat';
import loadable from '@common/react/loadable/loadableSettings';

const AdaptiveCardsNode = loadable(() =>
	import(/* webpackChunkName: "AdaptiveCardsNode" */ '@common/react/components/Chat/AdaptiveCards/AdaptiveCardsNode'));

export const AdaptiveCardsPlugin: ChatPlugin = {
	messageAttachment: (message) => {
		return (message.attachment ? <React.Fragment key="file">
			<AdaptiveCardsNode chatId={message.chatId} payload={message.attachment} />
		</React.Fragment> : null);
	},
	options: {
		customOnExecuteAction: () => null,
	},
};
